import { get, post, getBolb } from '@/apis/http';
import { apiPath } from '@/config';

// 今日汇率

export function getTodayData(data, header) {
    return post(apiPath + '/common/getRate', data, header)
}

//获取最近一周汇率
export function getWeekData(data, header) {
    return post(apiPath + '/common/outRateLogs', data, header)
}


// 抽奖
export function luckDraw(data) {
    return post(apiPath + '/uc/userlotteryinfo/lottery', data)
}

// 抽奖次数

export function searchUserNum(data) {
    return post(apiPath + '/uc/turntablenumstatus/findall', data)
}
//获取用户抽奖记录

export function searchUserHistory(data) {
    return post(apiPath + '/uc/turntablelog/findall', data)
}


// 投票
export function activityVote(data) {
    return post(apiPath + '/uc/voteActivity', data)
}

// 投票详情
export function VoteDetails(data) {
    return post(apiPath + '/uc/voteActivity/activityInfo', data)
}

//转盘详情
export function searchId(data, header) {

    return post(apiPath + '/common/turntable/findall', data, header)
}
//任务列表
export function getQuestList(data) {
    return get(apiPath + '/uc/userPoint/getSendStatus', data)
}

//兑换抽奖次数
export function exchangePoints(data) {
    return get(apiPath + '/uc/userPoint/exchangeTurntableNum', data)
}
